export default [
  {
    path: '/banner-iframe',
    name: 'PageBanner',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/common/PageBanner'),
    meta: { modular: -1, info: '魔点校园——banner' }
  },
  {
    path: '/filter',
    name: 'PageCommonFilter',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/common/PageCommonFilter'
      ),
    meta: { modular: -1, title: '筛选', info: '魔点校园——筛选' }
  },
  {
    path: '/middle',
    name: 'PageActiveMiddle',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/common/PageActiveMiddle'
      ),
    meta: { modular: -1, info: '魔点校园——设备激活' }
  },
  {
    path: '/mode',
    name: 'PageMode',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/common/PageMode'),
    meta: { modular: -1, title: '选择模式', info: '班牌——选择班牌模式' }
  },
  {
    path: '/role',
    name: 'PageCommonRoleChange',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/common/PageCommonRoleChange'
      ),
    meta: { modular: -1, info: '魔点校园——角色选择' }
  },
  {
    path: '/banner1',
    name: 'PageBanner1',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/common/PageBanner1'),
    meta: { modular: -1, info: 'banner——测温宣传' }
  },
  {
    path: '/banner2',
    name: 'PageBanner2',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/common/PageBanner2'),
    meta: { modular: -1, info: 'banner——班牌宣传' }
  },
  {
    path: '/banner3',
    name: 'PageBanner3',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/common/PageBanner3'),
    meta: { modular: -1, info: 'banner——亲情通话宣传' }
  },
  {
    path: '/banner4',
    name: 'PageBanner4',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/common/PageBanner4'),
    meta: { modular: -1, info: 'banner——课堂共创计划' }
  },
  {
    path: '/banner5',
    name: 'PageBanner5',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/common/PageBanner5'),
    meta: { modular: -1, info: 'banner——1+X课后服务' }
  },
  {
    path: '/banner6',
    name: 'PageBanner6',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/common/PageBanner6'),
    meta: { modular: -1, info: 'banner——智能排课' }
  },
  {
    path: '/banner6_paper',
    name: 'PageBanner6Paper',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/common/PageBanner6Paper'
      ),
    meta: { modular: -1, title: '立即领取', info: 'banner——智能排课_问卷表' }
  },
  {
    path: '/banner6_schedule',
    name: 'PageBanner6Schedule',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/common/PageBanner6Schedule'
      ),
    meta: { modular: -1, info: 'banner——智能排课_介绍' }
  },
  {
    path: '/banner7',
    name: 'PageBanner7',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/common/PageBanner7'),
    meta: { modular: -1, info: 'banner——智能排课' }
  },
  {
    path: '/banner8',
    name: 'PageBanner8',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/common/PageBanner8'),
    meta: { modular: -1, info: 'banner——教务系统' }
  },
  {
    path: '/banner9',
    name: 'PageBanner9',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/common/PageBanner9'),
    meta: { modular: -1, info: 'banner——请假返校' }
  },
  {
    path: '/scan',
    name: 'Scan',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/datascreen/scan'),
    meta: { modular: -1, title: 'banner——扫码识别' }
  }
]
